import { Group, Text } from "@mantine/core";
import { LinkAnchorToVentHome } from "./LinkAnchors";

interface Props {
  label: string;
  ventId: string;
  ventName: string;
  size?: string;
}
export const TabHeader = (props: Props) => {
  return (
    <Group gap="5px">
      <Text mt="0" size="xl">
        {props.label}
      </Text>
      <LinkAnchorToVentHome ventId={props.ventId} size="xl">
        {props.ventName}
      </LinkAnchorToVentHome>
    </Group>
  );
};

interface AdminTabHeaderProps {
  label: string;
  size?: string;
}
export const AdminTabHeader = (props: AdminTabHeaderProps) => {
  return (
    <Group gap="5px">
      <Text mt="0" size="xl">
        {props.label}
      </Text>
    </Group>
  );
};
